import { CONFIG_GRID_DEFAULT } from '../constants/tabela_generecia'
import { Grid } from 'gridjs'
import { capitalize, uniqBy, merge } from 'lodash'

export default {
	methods: {
		iniciarTabelaGenerica(
			columns,
			url,
			customThenCallback,
			customTotalCallback,
			options = CONFIG_GRID_DEFAULT
		) {
			const defaultConfig = {
				server: {
					url: url,
					then: (data) => customThenCallback(data),
					total: (data) => {
						const result = customTotalCallback(data)
						return typeof result === 'number' ? result : result.length
					},
				},
				search: false,
				pagination: {
					enabled: false,
					limit: 10,
					summary: false,
					server: {
						url: (urlApi, page, limit) =>
							`${urlApi}&page=${++page}&paginate_by=${limit}`,
					},
				},
			}

			const finalConfig = merge({}, CONFIG_GRID_DEFAULT, defaultConfig, options)

			const gridInstance = new Grid({
				columns,
				...finalConfig,
			})

			return gridInstance
		},
	},
}
